module.exports = __webpack_public_path__ + "img/frontend_base_smart.d8a80ce0.jpg";